import React from 'react'

import SmsRegistrationLayout, {
  StyledCopy,
} from 'src/components/Settings/Business/SmsRegistrationLayout'
import { Button } from 'src/stories/Button'
import { HelperWidget } from 'src/stories/HelperWidget'
import { WizardLayout } from 'src/stories/Wizard'
import { ProTipIcon } from 'src/stories/assets'

interface OverviewStepProps {
  nextStep: () => void
}

const OverviewStep: React.FC<OverviewStepProps> = ({ nextStep }) => (
  <WizardLayout
    asideContent={
      <>
        <HelperWidget
          title="Before you get started"
          icon={ProTipIcon}
          copy={
            <ul>
              <li>
                Have your 9-digit EIN (Tax ID) handy (sole proprietors excluded)
              </li>
              <li>
                You can locate your EIN on your tax preparation documents or
                financing documents provided by your bank
              </li>
            </ul>
          }
        />
      </>
    }
  >
    <SmsRegistrationLayout
      title="Overview"
      buttonNext={
        <Button
          size="large"
          action="primary"
          label="Get Started"
          baseDataAttribute="sms-registration-get-started"
          onClick={nextStep}
        />
      }
    >
      <StyledCopy>
        In an effort to prevent spam messages, phone carriers are enforcing an
        effort nicknamed "A2P 10DLC" to register business numbers. In order to
        utilize text marketing features to generate reviews and communicate with
        customers, you must complete this SMS registration.
      </StyledCopy>
    </SmsRegistrationLayout>
  </WizardLayout>
)

export default OverviewStep
